export * from "./NewRecordPage";
